<template>
  <div class="p-3" style="background-color: white;">
    <div class="mb-3">
      <h2 style="margin-bottom: 0px;">{{ displayName }}</h2>
      <p style="color: black;">ID: {{ id }}</p>
    </div>
    <campaign-overview
      :id="id"
      :agency="agency"
      :packageTitle="packageTitle"
      :property="property"
      :bookedBy="bookedBy"
      :bookedAt="bookedAt"
      :startDate="startDate"
      :endDate="endDate"
      :status="status"
      :associatedCampaignId="associatedCampaignId"
      :type="type"
    ></campaign-overview>
    <signifi-calls
      :id="id"
      :signifiProductResponse="signifiProductResponse"
      :signifiOrderResponse="signifiOrderResponse"
      :status="status"
      @on-signifi-called="handleUpdated()"
    ></signifi-calls>
    <campaign-status
      :id="id"
      :status="status"
      @on-campaign-cancelled="handleUpdated()"
    ></campaign-status>
    <campaign-dates-form
      :id="id"
      :startDate="startDate"
      :endDate="endDate"
      :status="status"
      @on-campaign-dates-updated="handleUpdated()"
    ></campaign-dates-form>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
      <div>
        <facebook-ad-preview :id="id" :facebookPreviewIframe="facebookPreview"></facebook-ad-preview>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import CampaignDatesForm from './CampaignDatesForm.vue';
import SignifiCalls from './SignifiCalls.vue';
import CampaignStatus from './CampaignStatus.vue';
import CampaignOverview from './CampaignOverview.vue';
import FacebookAdPreview from './FacebookAdPreview.vue';

export default {
  data() {
    return {
      note: null,
    };
  },
  props: [
    'id',
    'displayName',
    'agency',
    'packageTitle',
    'property',
    'bookedBy',
    'bookedAt',
    'startDate',
    'endDate',
    'status',
    'signifiOrderResponse',
    'signifiProductResponse',
    'associatedCampaignId',
    'type',
    'facebookPreview'
  ],
  components: {
    CampaignOverview,
    CampaignDatesForm,
    SignifiCalls,
    CampaignStatus,
    FacebookAdPreview,
  },
  methods: {
    handleUpdated() {
      this.$emit('on-campaign-updated');
    },
  },
};
</script>
